import type { FaireProductEntity } from "../../entity_types/product";

export const p_4uhmbql5qk: FaireProductEntity = {
  token: "p_4uhmbql5qk",
  type: "product",
  name: "It's Always OK To Buy More Books Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/e12ed77134899dbaad88def4e957500a4dd06a59107127f37c1934f759544a78.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a2a6ce3f5ca4d71a8c69f190c445c0d4399051e2ed0425f7accd2aa8861bf819.jpeg",
    "https://cdn.faire.com/fastly/ef7702e30e528045687b370c8b72c7498626e4055d949de9a70849b5088c9dad.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/2b62eaa6ab642c95e93362873f1412bbdaab2bb50823eaad64479f8bdeec8fe8.jpeg",
    "https://cdn.faire.com/fastly/427091abeafd4f6c943327dc74e086962fd415c376aa5c2f03c2aea6b9286ee9.jpeg",
    "https://cdn.faire.com/fastly/f0c924f2c6186ff8af1f429414389fc56236f608e1aac9769db19c1c75781d52.jpeg"
  ],
  priceDollars: 6.75,
  description: "For some of us, it's that musty paper smell of the local used bookstore that keeps us coming back. For others, it's the feeling of getting lost between pages as we embark on adventures in print.  For many, it's just to decorate the house to look more cultured than you actually are. Whatever your reason, we're here to tell you; IT'S ALWAYS OKAY TO BUY MORE BOOKS! \n\nWhether you're an avid reader, a librarian, or just trying to look smarter, we promise to NEVER judge a foot by its cover ;)\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:08.137Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
